
import makerjs from "makerjs";
function B38(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,R = Param[2].param,T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       t = T * 1 * myZoom,
       r = R * 1 * myZoom,
       s1 = S1 * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = (b-s1)/2, x1 = 0, x2 =(b-t)/2 ,x3 =b-(b-t)/2 ,x4 =b ,x5 =b-(b-s1)/2 , 
       y0 = 0, y1 =r,y2 =l, y3 =l,y4 =r,y5 =0,glassH =l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  } if (t !== 0) {
    var TxtT = "T="+T;
  }  if (r !== 0) {
    var TxtR = "R="+R;
  } if (s1 !== 0) {
    var TxtS1 = "S1="+S1;
  } 



   var drawAbnormalShapeB38 = {
       paths: {
        "LeftLine1": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "LeftLine2": new makerjs.paths.Line([x1, y1], [x2,y2]),
        "TopLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "RightLine1":new makerjs.paths.Line([x3,y3], [x4,y4]), 
        "RightLine2":new makerjs.paths.Line([x4,y4], [x5,y5]),
        "BottomLine": new makerjs.paths.Line([x5,y5], [x0, y0]),
       }
   };
   var drawAbnormalShapeB38MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x1- markShift, y0], [x1- markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x1, y2], [x1- 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x1, y0], [x1- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB38MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x4+ markShift, y4], [x4+ markShift, y5]),
        "RightShortUpline": new makerjs.paths.Line([x4, y4], [x4+ 2 * markShift, y4]),
        "RightShortDnline": new makerjs.paths.Line([x4, y5], [x4+ 2 * markShift, y5]),
       }
   };
   var drawAbnormalShapeB38MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x1, y0- markShift], [x4, y5- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x1, y0], [x1, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x4, y5], [x4, y5 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB38MarkS1 = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- 4*markShift], [x5, y5- 4*markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 5 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x5, y5], [x5, y5 - 5 * markShift]),
       }
  
   };
   var drawAbnormalShapeB38MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x2, y2+ markShift], [x3, y3+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB38MarkB, TxtB, [x0, y0 - 2 * markShift], [x5, y5 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB38MarkT, TxtT, [x2, y2+ 2*markShift], [x3, y3+ 2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB38MarkL, TxtL, [x1-2*markShift, y0], [x1-2*markShift, y2]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB38MarkR, TxtR, [x4+ 3*markShift, y4], [x4+ 3*markShift, y5]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB38MarkS1, TxtS1, [x0, y0- 6*markShift], [x5, y5- 6*markShift]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB38: drawAbnormalShapeB38,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB38: drawAbnormalShapeB38,
        drawAbnormalShapeB38MarkL: drawAbnormalShapeB38MarkL,
        drawAbnormalShapeB38MarkT: drawAbnormalShapeB38MarkT,
        drawAbnormalShapeB38MarkB:drawAbnormalShapeB38MarkB,
        drawAbnormalShapeB38MarkR:drawAbnormalShapeB38MarkR,
        drawAbnormalShapeB38MarkS1:drawAbnormalShapeB38MarkS1,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B38;